import {
    getDataStructure,
    getColumnDefinitions
} from '~/shared/src/utilities/modules/finderReferencePanel';

import {store} from '~/frontend/src/store';
import {
    defaultProps as referencePanelDefaultProps,
    ComponentProps as ReferencePanelComponentProps
} from '~/frontend/src/components/base/ItemFinder/detail/ReferencePanel/index';


export default {
    hydrate( inboundState : ReferencePanelComponentProps ) : ReferencePanelComponentProps {
        return inboundState;
    },

    rehydrate( outboundState : ReferencePanelComponentProps ) : ReferencePanelComponentProps {
        const retVal       = {
                  ...outboundState
              },
              schema       = outboundState.schema ?? referencePanelDefaultProps.schema,
              status       = outboundState.status ?? referencePanelDefaultProps.status,
              timestamp    = outboundState.timestamp ?? referencePanelDefaultProps.timestamp,
              itemTypeName = outboundState.itemTypeName ?? referencePanelDefaultProps.itemTypeName,
              parentItemTypeName = outboundState.parentItemTypeName,
              user         = store.getState()?.session?.user;

        if ( user ) {
            retVal.dataStructure = getDataStructure( schema, itemTypeName, parentItemTypeName, user );
            if ( retVal.dataStructure ) {
                retVal.columnDefinitions = getColumnDefinitions( retVal.dataStructure, schema, status, timestamp, itemTypeName, user );
            }
        }

        return retVal;
    }
};
